<span class="version-container">
 {{version}} {{suffix}}
 @if (showLtVersion) { <span class="lt-version">({{ltVersion}})</span>}
</span>
